import styled from "styled-components";

const ShadowImage = styled.img`
  ${({ width }) => {
    if (width) {
      return `width: ${width}`;
    }
  }};

  box-shadow: 0 0 10px #454545;
`;

export default ShadowImage;



// WEBPACK FOOTER //
// ./src/components/ShadowImage.js